import { BehaviorSubject } from "rxjs";
import BookmarksService from "../services/BookmarksService";
import {BookmarkProps} from "../types/bookmark";

const initial: Array<BookmarkProps> = [];
const BookmarksStore = {
  current$: new BehaviorSubject(initial),
  byId$: new BehaviorSubject({}),
  error$: new BehaviorSubject(null),
  pending$: new BehaviorSubject(false),
  async getBookmarks() {
    if (this.current$.getValue().length) {
      return this.current$.getValue();
    }
    this.pending$.next(true);
    try {
      const response:any = await BookmarksService.getBookmarks();
      if (response.data.success) {
        this.current$.next(response.data.bookmarks || []);
        this.pending$.next(false);
        this.error$.next(null);
        return response.data;
      }
      return this.current$.getValue();
    } catch (err) {
      this.pending$.next(false);
      this.error$.next(err);
      return err;
    }
  },
  async addBookmark(bookmark:BookmarkProps) {
    const oldBookmarks = this.current$.getValue();
    const newBookmarks:Array<BookmarkProps> = [
      ...oldBookmarks,
      bookmark,
    ];

    try {
      await BookmarksService.addBookmark(bookmark);
      // set new bookmarks
      this.current$.next(newBookmarks);
    } catch (err) {
      console.log('catch', err);
      this.error$.next(err);
      // in case of error, revert to old bookmarks
      this.current$.next(oldBookmarks);
      return err;
    }
  },
  async deleteBookmark(bookmark:BookmarkProps) {
    const current = this.current$.getValue();
    const old = { ...current };
    const idx = current.findIndex((b) => b.result_id === bookmark.result_id );
    current.splice(idx, 1);
    this.current$.next([...current]);
    try {
      await BookmarksService.deleteBookmark(bookmark.result_id);
      return current;
    } catch (err) {
      this.current$.next(old);
      this.error$.next(err);
      return err;
    }
  }
}

BookmarksStore.current$.subscribe((bookmarks) => {
  const byId:any = {};
  bookmarks.forEach(bookmark => {
    byId[bookmark.result_id] = { ...bookmark };
  });
  BookmarksStore.byId$.next(byId);
})

export default BookmarksStore;